import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Dialog as MuiDialog,
  Select,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { useAddRoleDialog } from './useAddRoleDialog';

interface AddRoleDialogProps {
  open: boolean;
  onClose: () => void;
  userId: string;
}

export const AddRoleDialog: FunctionComponent<AddRoleDialogProps> = ({
  open,
  onClose,
  userId,
}) => {
  const { roles, onSubmit, role, onRoleChange } = useAddRoleDialog(
    userId,
    onClose,
  );
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Ajouter un rôle</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Ajouter un rôle à cet utilisateur ?
        </DialogContentText>
        {roles.length > 0 ? (
          <Select value={role ?? roles[0]} onChange={onRoleChange}>
            {roles.map((role) => (
              <MenuItem key={role} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={onSubmit} autoFocus>
          Valider
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
